import {layoutDataType} from "../../../actions/layout/data/type";
import {validatePath} from "../../../../common/layout/mapper/Layout";


const initialState = {
    siderData: [],
    settingSider: [],
    otherSider: [],
    baseSider: [],
    type: null,
    loadSiderData: false,
    successLoadSiderData: false,
    error: null
}

const layoutDataReducer = (state = initialState,
                           action) => {
    switch (action.type) {
        case layoutDataType.LOAD_ALL_SIDER_DATA_START:
            return {
                ...state,
                params: action.params,
                loadSiderData: true,
                successLoadSiderData: false
            }
        case layoutDataType.LOAD_ALL_SIDER_DATA_SUCCESS:
            return {
                ...state,
                siderData: action.params.paths,
                settingSider: action.params.paths.find(element =>
                    validatePath(element.path) === "/setting"),
                otherSider: action.params.paths.filter(element =>
                    validatePath(element.path) === "/user"
                    || validatePath(element.path) === "/system"),
                baseSider: action.params.paths.filter(element => validatePath(element.path) !== "/setting"
                    && validatePath(element.path) !== "/system"
                    && validatePath(element.path) !== "/user"),
                type: action.params.type,
                loadSiderData: false,
                successLoadSiderData: true
            }

        case layoutDataType.LOAD_ALL_SIDER_DATA_ERROR:
            return {
                ...state,
                error: action.params,
                successLoadSiderData: false,
                loadSiderData: false
            };

        default:
            return state;
    }
}

export default layoutDataReducer;